import React, { Component } from 'react';
import SearchBar from './SearchBar';
import Sorting from './Sorting';
import Filter from './Filter';
import background from './background.jpg';
import AddItem from './AddItem';

export default class Header extends Component {
  render() {
    return (
      <div style={headerStyle}>
        <div className="logo" style={logoStyle}>
          <div style={{ color: 'white', fontWeight: 'bold' }}>Food</div>
          <div style={{ color: '#1B4E5A' }}>Book</div>
        </div>
        <SearchBar onChange={this.props.setSearch} />
        <AddItem onClick={this.props.addItem} />
        <div className="bar">
          <Sorting onClick={this.props.sortItems} />
          <Filter onClick={this.props.setFilter} />
        </div>
      </div>
    );
  }
}

const headerStyle = {
  backgroundImage: 'url(' + background + ')',
  backgroundSize: 'cover',
  backgroundRepeat: 'none',
  backgroundPosition: 'center'
};

const logoStyle = {
  padding: '2em',
  fontSize: '3em',
  display: 'flex',
  fontFamily: "'Lora', serif"
};
